import { HttpParams } from '@angular/common/http';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import {
  isArray,
  isEmpty,
  isNull,
  isUndefined,
  lowerCase,
  size,
  uniqBy,
} from 'lodash';
import { from, map, mergeMap } from 'rxjs';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { DATE_RANGE_OPTIONS } from 'src/app/shared/components/purple-date-picker/purple-date-picker.constant';
import { LRC_DEPOSITS, SERVER_URL } from 'src/app/shared/constants/apis-list';
import { UserPartnerConfigCMSFundsSource } from 'src/app/shared/interfaces/Partner';
import { IColumns, IUser } from 'src/app/shared/interfaces/User';
import {
  FundsWalletSource,
  PurplWallet,
} from 'src/app/shared/interfaces/Wallets';
import { UserService } from 'src/app/shared/services';

@Component({
  selector: 'app-generic-partner-dashboard',
  templateUrl: './generic-partner-dashboard.component.html',
  styleUrls: ['./generic-partner-dashboard.component.scss'],
})
export class GenericPartnerDashboardComponent
  extends ListingBaseComponent
  implements OnInit
{
  @Input() dateFrom?: Date;
  @Input() dateTo?: Date;

  view: any[] = [280, 280];
  colorScheme: any;

  colorUsers: any = {
    domain: ['#66023C', '#C7CED7'],
  };

  colorDeposits: any = {
    domain: ['#66023C', '#DB4147', '#C7CED7'],
  };

  colorDisbursements: any = {
    domain: ['#66023C', '#C7CED7'],
  };

  colorDeposits2: any = {
    domain: ['#DB4147'],
  };

  details: any;
  detailsUSD: any;

  userStatDetails: any;

  users: any = [];
  deposits: any = [];
  depositsUSD: any = [];
  depositsUSD2: any = [];

  DEPOSITS_AMOUNT: any = [];

  params: HttpParams = new HttpParams();
  queryParams: Params = {};

  filterValue: string = 'last_30_days';
  filterLabel?: string;
  dateFilters: any[] = [];
  DISC_DETAILS?: any;
  fromDate: Date | null = null;
  toDate: Date | null = null;

  loading = false;
  tableDataListItems: any[] = [];
  depositLabel?: string;
  userLabel?: string;

  funds?: string;
  fundsUSD?: string;

  FUND_WALLETS?:
    | UserPartnerConfigCMSFundsSource
    | UserPartnerConfigCMSFundsSource[]
    | null;
  FUNDS_WALLET_SRC?: FundsWalletSource[];
  FUNDS_WALLET_IDS?: Pick<PurplWallet, 'id'>[];
  FUNDS_WALLET_TYPE_IDS?: string[];
  PARTNER_WALLETS?: PurplWallet[];
  WALLET_BALANCE?: any;

  TOTAL_CASH_OUT_COMPLETED?: any;
  USERS_COUNT?: number;

  user: IUser | null = null;
  partner: string;
  CONFIG_SECTIONS?: Record<string, any>;
  DASHBOARD?: any;
  DASHBOARD_HEADER?: string;

  URL_endpoint?: string;
  URL_CASH_OUT?: string;
  URL_USERS_COUNT?: string;
  URL_TRANSFERS?: string;
  TOTAL_FUNDS?: string;

  constructor(
    injector: Injector,
    public userService: UserService,
  ) {
    super(injector);

    this.user = this.userService.user as IUser;
    const partner = this.user?.partner;
    const partner_config = partner?.config;
    const partner_config_funds = partner?.config?.cms?.funds;

    this.partner = lowerCase(partner?.name);
    this.CONFIG_SECTIONS = partner_config?.cms?.sections;
    this.DASHBOARD = this.CONFIG_SECTIONS?.dashboard?.pie_charts?.deposits;

    this.DASHBOARD_HEADER = this.DASHBOARD ? this.DASHBOARD?.label : 'Deposits';

    this.URL_endpoint =
      this.user?.partner?.type === 'ngo' ? LRC_DEPOSITS : SERVER_URL + '';

    this.URL_CASH_OUT =
      this.DASHBOARD?.portions?.total_completed_cash_out?.source?.endpoint
        .replace('GET /api/', '')
        .trim();

    this.URL_USERS_COUNT = this.CONFIG_SECTIONS?.users?.table?.source?.endpoint
      .replace('GET /api/', '')
      .trim();

    this.URL_TRANSFERS = this.DASHBOARD?.source?.endpoint
      .replace('GET /api/', '')
      .trim();

    this.colorScheme =
      this.user?.partner?.type === 'ngo'
        ? this.colorDeposits
        : this.colorDisbursements;

    this.DISC_DETAILS = this.DASHBOARD?.portions;

    this.FUND_WALLETS = !isUndefined(partner_config_funds?.wallets)
      ? partner_config_funds?.wallets
      : partner_config_funds?.wallet;

    if (isArray(this.FUND_WALLETS) && size(this.FUND_WALLETS) > 0) {
      const funds_wallets = this.FUND_WALLETS.map((item: any) => {
        const endpoint = item.source.endpoint;
        const splitpoint = endpoint.split(' ');
        const method = splitpoint[0];
        const url = splitpoint[1].replace('/api/', '');

        return {
          endpoint: item.source.endpoint,
          url,
          method,
        };
      }) as FundsWalletSource[];

      this.FUNDS_WALLET_SRC = uniqBy(funds_wallets, 'endpoint');
      this.FUNDS_WALLET_IDS = this.FUND_WALLETS.map((item: any) => ({
        id: item.source.id,
      }));
      // this.FUNDS_WALLET_TYPE_IDS =
      //   this.CONFIG_SECTIONS?.transactions?.table?.source?.initial_filters?.wallet_type_id;
    } else {
      const fund_wallets = this.FUND_WALLETS as UserPartnerConfigCMSFundsSource;
      const source = fund_wallets?.source;
      this.FUNDS_WALLET_SRC = [
        {
          endpoint: source?.endpoint,
          url: source?.endpoint.split(' ')[1].replace('/api/', ''),
          method: source?.endpoint.split(' ')[0],
        },
      ];
      this.FUNDS_WALLET_IDS = [
        {
          id: fund_wallets?.source?.id!,
        },
      ];
    }

    this.FUNDS_WALLET_TYPE_IDS =
      this.CONFIG_SECTIONS?.transactions?.table?.source?.initial_filters?.wallet_type_id;

    if (this.DISC_DETAILS) {
      this.setUsersTable();
    }
  }

  ngOnInit(): void {
    this.depositLabel =
      this.partner === 'nextcare'
        ? this.DISC_DETAILS.total_deposits?.label
        : 'Total funds';

    this.userLabel = 'Total registered';

    console.log('partnerpartner: ', this.partner);

    this.getUserStats();
    if (this.DASHBOARD) {
      this.getDeposits();
    }

    if (!isEmpty(this.FUNDS_WALLET_SRC)) {
      if (this.partner === 'nextcare') {
        this.getWalletBalanceNC(this.FUNDS_WALLET_SRC!);
      } else {
        this.getWalletBalance(this.FUNDS_WALLET_SRC!);
      }
    }
  }

  private setUsersTable(): void {
    for (let [key, value] of Object.entries(this.DISC_DETAILS!)) {
      const fieldValue = value as IColumns;

      if (fieldValue.display_in_disc === true) {
        const columns = [
          {
            name: fieldValue?.label,
            value: fieldValue?.data_paths?.value,
            currency: fieldValue?.data_paths?.currency,
            percent: fieldValue?.data_paths?.percent,
          },
        ];
        this.depositsUSD2.push(columns);
      }
    }
  }

  getDepositStatsLBP(params?: HttpParams) {
    this.params = this.params.set('currency', 'LBP');

    this.dataService
      .fetchData({
        apiUrl: this.URL_endpoint!,
        method: 'GET',
        contentType: 'application/json',
        params: this.params,
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        }),
      )
      .subscribe((response: any) => {
        this.details = response;
        this.funds = Number(this.details?.total_funds?.value).toFixed(2);

        this.deposits = [
          {
            image: './assets/images/svg/deposits.svg',
            name: 'Total deposits',
            value: response?.total_accepted_funds?.value,
            currency: response?.total_accepted_funds?.currency,
            percent: response?.total_accepted_funds?.percent,
          },
          {
            image: './assets/images/svg/rejected.svg',
            name: 'Total rejected',
            value: response?.total_rejected_funds?.value,
            currency: response?.total_rejected_funds?.currency,
            percent: response?.total_rejected_funds?.percent,
          },
          {
            image: './assets/images/svg/pending.svg',
            name: 'Total pending',
            value: response?.total_unaccepted_funds?.value,
            currency: response?.total_unaccepted_funds?.currency,
            percent: response?.total_unaccepted_funds?.percent,
          },
        ];
      });
  }

  //Disbursement nextcare
  getDeposits(params?: HttpParams) {
    this.params = this.params.set('currency', 'USD');

    this.dataService
      .fetchData({
        apiUrl: SERVER_URL + this.URL_TRANSFERS,
        method: 'GET',
        contentType: 'application/json',
        params: this.params,
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        }),
      )
      .subscribe((response: any) => {
        this.DEPOSITS_AMOUNT = [
          {
            index: 0,
            image: './assets/images/svg/deposits.svg',
            name:
              this.partner === 'nextcare' ? 'Accepted funds' : 'Total deposits',
            value: response?.total_accepted_funds?.value,
            currency:
              response?.total_accepted_funds?.currency === 'USD'
                ? '$'
                : response?.total_accepted_funds?.currency,
            percent: response?.total_accepted_funds?.percent,
          },
          {
            index: 1,
            image: './assets/images/svg/rejected.svg',
            name: this.DASHBOARD?.portions?.total_rejected?.label
              ? this.DASHBOARD?.portions?.total_rejected?.label
              : 'Total rejected',
            value: response?.total_rejected_funds?.value,
            currency:
              response?.total_accepted_funds?.currency === 'USD'
                ? '$'
                : response?.total_accepted_funds?.currency,
            percent: response?.total_rejected_funds?.percent,
          },
          {
            index: 2,
            image: './assets/images/svg/pending.svg',
            name:
              this.partner === 'nextcare' ? 'Pending funds' : 'Total pending',
            value: response?.total_unaccepted_funds?.value,
            currency:
              response?.total_accepted_funds?.currency === 'USD'
                ? '$'
                : response?.total_accepted_funds?.currency,
            percent: response?.total_unaccepted_funds?.percent,
          },
        ];

        this.TOTAL_FUNDS = Number(response?.total_funds?.value).toFixed(2);

        if (this.partner === 'nextcare') {
          this.DEPOSITS_AMOUNT = this.DEPOSITS_AMOUNT.filter((item: any) => {
            return item.index !== 1;
          });
        } else {
          this.DEPOSITS_AMOUNT = this.DEPOSITS_AMOUNT;
        }
      });
  }

  getUserStats(params?: HttpParams) {
    this.dataService
      .fetchData({
        apiUrl: this.apiList.LRC_STATS,
        method: 'GET',
        contentType: 'application/json',
        params,
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        }),
      )
      .subscribe((response: any) => {
        this.userStatDetails = response;
        this.users = [
          {
            name: 'Total Onboarded',
            value: response?.total_onboarded?.value,
          },
          { name: 'Total Pending', value: response?.total_pending?.value },
        ];
      });
  }

  getWalletBalanceNC(wallet_sources: FundsWalletSource[]) {
    from(wallet_sources)
      .pipe(
        mergeMap((source) =>
          this.dataService.fetchData({
            apiUrl: `${SERVER_URL}${source.url}`,
            method: source.method,
            contentType: 'application/json',
          }),
        ),
      )
      .pipe(
        map((response) =>
          response && response.results ? response.results : [],
        ),
      )
      .subscribe({
        next: (response) => {
          const filtereWallets: PurplWallet[] = response.filter((item: any) => {
            return this.FUNDS_WALLET_IDS?.some((tag) => tag.id === item.id);
          });

          this.PARTNER_WALLETS = filtereWallets;
        },
      });
    // .subscribe((wallets: PurplWallet[]) => {
    //   console.log('wallets: ', wallets);
    //   const filtered: PurplWallet[] = wallets.filter((wallet) =>
    //     this.FUNDS_WALLET_IDS?.some((tag) => tag.id === wallet.id)
    //   );

    //   const filtereWallets = filtered.filter((wallet) =>
    //     this.FUNDS_WALLET_TYPE_IDS?.some(
    //       (tag) => tag === String(wallet.wallet_type_id)
    //     )
    //   );

    //   this.PARTNER_WALLETS = filtereWallets;
    //   console.log('PARTNER_WALLETS: ', this.PARTNER_WALLETS);
    // });
  }

  getWalletBalance(wallet_sources: FundsWalletSource[]) {
    from(wallet_sources)
      .pipe(
        mergeMap((source) =>
          this.dataService.fetchData({
            apiUrl: `${SERVER_URL}${source.url}`,
            method: source.method,
            contentType: 'application/json',
          }),
        ),
      )
      .pipe(
        map((response) =>
          response && response.results ? response.results : [],
        ),
      )
      .subscribe((wallets: PurplWallet[]) => {
        const filtered: PurplWallet[] = wallets.filter((wallet) =>
          this.FUNDS_WALLET_IDS?.some((tag) => tag.id === wallet.id),
        );

        const filtereWallets = filtered.filter((wallet) =>
          this.FUNDS_WALLET_TYPE_IDS?.some(
            (tag) => tag === String(wallet.wallet_type_id),
          ),
        );

        this.PARTNER_WALLETS = filtereWallets;
      });
  }

  onDateSelection(event: any) {
    const options: any = DATE_RANGE_OPTIONS.find(
      (item) => item.value === event.filter,
    );
    this.filterValue = options?.value;
    this.filterLabel = options?.label;
    this.fromDate = event.startDateJS;
    this.toDate = event.endDateJS;
    this.dateFilters = options.filters;

    this.params = this.params.set(
      'datetime_created__gte',
      this.fromDate?.toISOString()!,
    );
    this.params = this.params.set(
      'datetime_created__lte',
      this.toDate?.toISOString()!,
    );

    this.getDepositStatsLBP(this.params);

    this.getUserStats(this.params);
  }

  onChartNavigate(ev: any) {}
}

// DO NOT DELETE YET
// .pipe(
//   map((response) => {
//     console.log('response: ', response);
//     return response ? response.results : [];
//   })
// )
// .subscribe((wallets: PurplWallet[]) => {
//   console.log('wallets: ', wallets);
//   // const filtered: PurplWallet[] = wallets.filter((wallet) =>
//   //   this.FUNDS_WALLET_IDS?.some((tag) => tag.id === wallet.id)
//   // );
//   // console.log('filtered: ', filtered);

//   // console.log('FUNDS_WALLET_TYPE_IDS: ', this.FUNDS_WALLET_TYPE_IDS);
//   // const filtereWallets = filtered.filter((wallet) =>
//   //   this.FUNDS_WALLET_TYPE_IDS?.some(
//   //     (tag) => tag === String(wallet.wallet_type_id)
//   //   )
//   // );
//   // console.log('filtereWallets: ', filtereWallets);
//   // this.PARTNER_WALLETS = filtereWallets;
// });
